"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconSms = Experimental__IconSms;
exports.IconSms = IconSms;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * @deprecated IconSms is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function IconSms(props) {
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M0 8c0 1.55.54 2.955 1.619 4.214L.492 14.85c-.137.317-.141.54-.012.67.13.13.353.126.67-.011l3.096-1.325A8.86 8.86 0 008 15a8.793 8.793 0 003.111-.556c.99-.37 1.84-.867 2.552-1.492a7.075 7.075 0 001.702-2.234C15.788 9.853 16 8.948 16 8a6.11 6.11 0 00-.635-2.718 7.075 7.075 0 00-1.702-2.234c-.712-.625-1.563-1.122-2.552-1.492A8.794 8.794 0 008 1a8.794 8.794 0 00-3.111.556c-.99.37-1.84.867-2.552 1.492A7.075 7.075 0 00.635 5.282 6.106 6.106 0 000 8zm5 1H3V7h2v2zm4 0H7V7h2v2zm4 0h-2V7h2v2z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M2 12c0 1.938.675 3.693 2.024 5.267l-1.409 3.296c-.172.396-.177.675-.015.837.163.163.442.158.837-.014l3.87-1.656c1.476.68 3.04 1.02 4.693 1.02 1.356 0 2.652-.232 3.889-.695 1.236-.462 2.3-1.084 3.19-1.865a8.843 8.843 0 002.127-2.793c.53-1.08.794-2.213.794-3.397a7.637 7.637 0 00-.794-3.398A8.843 8.843 0 0019.08 5.81c-.89-.78-1.954-1.402-3.19-1.865A10.993 10.993 0 0012 3.25c-1.356 0-2.652.232-3.889.695-1.236.462-2.3 1.084-3.19 1.865a8.844 8.844 0 00-2.127 2.792A7.632 7.632 0 002 12zm6.25 1.25h-2.5v-2.5h2.5v2.5zm5 0h-2.5v-2.5h2.5v2.5zm5 0h-2.5v-2.5h2.5v2.5z\'/>'
  }];
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = props.autoMirror || false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated IconSms is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function Experimental__IconSms(props) {
  return /*#__PURE__*/_react["default"].createElement(IconSms, props);
}